import { render, staticRenderFns } from "./CreditorListListView.vue?vue&type=template&id=328928a4"
import script from "./CreditorListListView.vue?vue&type=script&lang=js"
export * from "./CreditorListListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports